import  Geocode  from "react-geocode";

// validate pincode based on state
const postalPincodeAPI = "https://api.postalpincode.in/pincode"
export const validatePinCode = async (pinCode, state) => {
  const pinCodePattern = /^[1-9]{1}[0-9]{5}$/;
  if (pinCodePattern.test(pinCode)) {
    try {
      const response = await fetch(`${postalPincodeAPI}/${pinCode}`);
      const data = await response.json();
      //   console.log("data pincode: ", data);

      if (data[0].Status === "Success") {
        const { State, Country, District } = data[0].PostOffice[0];

        if (
          state
            .toLowerCase()
            .replace("&", "and")
            .includes(State.toLowerCase().replace("&", "and"))
        ) {
          return { value: "", flag: true };
        } else {
          return { value: "Invalid PIN code", flag: false };
        }
      } else {
        return { value: "Invalid PIN code", flag: false };
      }
    } catch (error) {
      return { value: "Error validating PIN code", flag: false };
    } finally {
    }
  } else {
    return { value: "Pin code must be 6 digits", flag: false };
  }
};




// Set your API key
Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAP_API_KEY);
// to extract the city from the address+
export const extractCity = async (address) => {
  try {
    const response = await Geocode.fromAddress(address);
    const addressComponents = response.results[0].address_components;
    const city = addressComponents.find((component) =>
      component.types.includes("locality")
    );
    return city ? city.long_name : "";
  } catch (error) {
    console.error("Error fetching city:", error);
    return "";
  }
};

